import { Reveal } from "./Reveal";
import { STEPS } from "../lib/site";

export default function ProcessSteps({ detailed = false }) {
  return (
    <ol className="relative mx-auto max-w-3xl">
      <div className="stitch-vertical absolute left-[27px] top-4 bottom-10 hidden sm:block" aria-hidden="true" />
      {STEPS.map((step, i) => (
        <li key={step.num} className="relative sm:pl-20 sm:pb-14 last:pb-0">
          <Reveal delay={i * 0.05}>
            <div className="relative flex items-start gap-5 sm:gap-0">
              <span
                className={`relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-full font-serif text-lg font-semibold ${
                  detailed
                    ? "bg-forest text-ivory"
                    : "border border-inkline bg-warmwhite text-forest"
                }`}
                aria-hidden="true"
              >
                {step.num}
              </span>
              <div className="sm:pl-8">
                <p className="text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-clay">
                  {step.title}
                </p>
                <h3 className="mt-2 font-serif text-2xl font-medium text-forest md:text-[1.75rem]">
                  {step.lead}
                </h3>
                <p className="mt-3 max-w-xl leading-[1.7] text-charcoal/80">{step.body}</p>
                {detailed && (
                  <div className="mt-5 max-w-xl rounded-xl border border-inkline bg-sage-mist p-5">
                    <p className="text-[0.7rem] font-semibold uppercase tracking-[0.16em] text-forest/60">
                      What to expect
                    </p>
                    <p className="mt-2 leading-[1.65] text-charcoal/80">{step.expect}</p>
                    <p className="mt-4 text-[0.7rem] font-semibold uppercase tracking-[0.16em] text-forest/60">
                      What helps us begin
                    </p>
                    <p className="mt-2 leading-[1.65] text-charcoal/80">{step.bring}</p>
                  </div>
                )}
              </div>
            </div>
          </Reveal>
        </li>
      ))}
    </ol>
  );
}
